<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>

<script>
import getLodop from "@/utils/lodop";
import {
  getList,
	del,
	update,
	add,
	inboundSave,
	inboundList,
	printTag
} from "@/api/tracker/warehousingNumber";
import { getAllClient } from "@/api/user/client";
import cTable from "@/base/common/index";
import { getWarehouse } from "@/api/storage/warehouse";
import Goods from '../warehousing/goods'
export default {
  name: "warehousingNumber",
	components:{
		cTable
	},
  async created() {
		let allClient = (await getAllClient()).data.payload.rows;
		
		this.header.searchs.forEach(async (item) => {
		  if (item.key === "client_id") item.options = allClient;
			if (item.key === "warehouse_id")item.options = (await getWarehouse()).data.payload.rows;
		});
		this.modals.add.fields.forEach(async (item) => {
		  if (item.key === "client_id") item.options = allClient;
		});
  },
  methods: {},
  data() {
    let that = this;
    return {
      methods: {
        list: getList,
        del,
        update,
        add,
				inboundSave,
				inboundList,
				printTag
      },
      modals: {
				info:{
					config:{
						title:this.$t('warehousingInformation'),
						width:80,
						expandConfig: {
						  expandAll: true,
						  // accordion: true,
						  reserve: true,
						},
					},
					footer:{
						show:()=>false
					},
					table:{
						config:{
							height:600,
							resize:false
						},
						fields:[
							{
							  width: 35,
							  type: "expand",
							  showOverflow: false,
							  expandRender: (h, p) => {
							    return h(Goods, {
							      props: {
											read:true,
							        list: p.row.goods,
							      },
							    });
							  },
							},
							{
							  name: this.$t("batch_number"),
							  key: "batch_number",
							  minWidth: 120,
							},
							{
							  name: this.$t("warehouseName"),
							  key: "warehouse_name",
							  minWidth: 120,
							},
							{
							  name: this.$t("inbound")+this.$t("noofpieces"),
							  key: "quantity",
							  minWidth: 120,
							},
							{
							  name: this.$t("inbound")+this.$t("Weight"),
							  key: "weight",
							  minWidth: 120,
							},
							{
							  name: this.$t("inbound")+this.$t("skuVolume"),
							  key: "volume",
							  minWidth: 120,
							},
							{
							  name: this.$t("Remarks"),
							  key: "remarks",
							  minWidth: 120,
							},
							{
							  name: this.$t("createUser"),
							  key: "create_name",
							  minWidth: 120,
							},
							{
							  name: this.$t("inboundTime"),
							  key: "create_time",
							  minWidth: 120,
							},
							{
							  type: "btns",
							  width: 150,
							  name: () => this.$t("operation"),
							  list: [
							    {
							      name: () => this.$t("update"),
							      type: "update",
							      fnName: "updateFun",
							      bind: {
							        type: "success",
							      },
							    },
									{
									  name: () => this.$t("print"),
									  type: "print",
									  fnName: "printFun",
									  bind: {
									    type: "success",
									  },
									},
							  ],
							  methods: {
									printFun({row}){
										this.handleRequestMethods('printTag',row.id).then(res=>{
											console.log(res);
											let lodop = getLodop(this)
											res.payload.forEach((item,index)=>{
												lodop.SET_PRINT_PAGESIZE(1, "100mm", "100mm", ""); //规定纸张大小；使用A4纸
												lodop.SET_PRINT_STYLEA(0, "AlignJustify", false); //ItemType:设置上面的为页眉页脚，每页固定位置输出
												lodop.SET_PRINT_STYLE("Bold", 0);
												lodop.SET_PRINT_STYLE("FontSize", 10);
												lodop.ADD_PRINT_BARCODE(
													"10mm",
													"12mm",
													"80mm",
													"20mm",
													"128Auto",
													item.number
												);
												
												lodop.SET_PRINT_STYLE("Bold", 1);
												lodop.SET_PRINT_STYLE("FontSize", 20);
												lodop.ADD_PRINT_TEXT("40mm", "10mm", "90mm", "20mm", item.company+'\n'+item.account);
												lodop.SET_PRINT_STYLE("Alignment", 3);
												lodop.ADD_PRINT_TEXT("90mm", "10mm", "85mm", "20mm", item.batch);
												if (index != res.payload.length - 1) {
													lodop.NEWPAGE();
												}
											})
											lodop.PREVIEW()
										})
										
									},
							    async updateFun({ row }) {
										let modal = this.getModal('info')
										let params = {tid:modal.params.tid,warehouse_number:modal.params.warehouse_number}
										this.getModal('addInfo').open(Object.assign(params,row))
							    },
							  },
							},
						]
					}
				},
				addInfo:{
					methods: {
					  ok({ row, close }) {
					    this.$page.handleRequestMethods('inboundSave', row, true).then((e) => {
					      this.$page.handleRequestMethods('inboundList',{id:this.params.tid}).then(res=>{
					      	this.$page.getModal('info').list = res.payload
					      })
					      close();
					    });
					  },
					},
					type:'add',
					config: {
						title:this.$t('warehousing'),
					  modalBind: {
					    styles: {
					      top: "30px",
					    },
					    width: 80,
					  },
					  formBind: {
					    labelWidth: 120,
					  },
					  rowBind: {
					    gutter: 13,
					    style: {
					      marginBottom: "20px",
					    },
					  },
					  rules: {
							quantity: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "blur",
									type:'number',
									min:1,
									max:9999
							  },
							],
							weight: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "blur",
									type:'number',
									min:1,
									max:99999
							  },
							],
							width: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "blur",
									type:'number',
									min:1,
									max:999
							  },
							],
							length: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "blur",
									type:'number',
									min:1,
									max:999
							  },
							],
							height: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "blur",
									type:'number',
									min:1,
									max:999
							  },
							],
					  },
					},
					grid: [
					  {warehouse_number:24},
					  {quantity:24},
					  {weight:24},
					  // {length:8,width:8,height:8},
					  {volume:24},
					  // {create_time:24},
					  {remarks:24},
					  {goods:24},
					],
					fields:[
						{
						  key: "goods",
						  name: ()=> this.$t('des_goods') + this.$t('information'),
							render:(h,p)=>{
								if(!p.row.goods)return
								if(!p.row.goods.length)p.row.goods.push({
									name:'',
									sku:'',
									length:0,
									height:0,
									width:0,
									quantity:0,
									volume:0,
									weight:0,
								})
								return h(Goods,{attrs:{
									row:p.row,
									list:p.row.goods
								}})
							}
						},
						{
							name: this.$t("noofpieces"),
							component: "InputNumber",
							bind:{
								style:'width:100%'
							},
							default:0,
							placeholder:()=>this.$t("enter")+this.$t("noofpieces"),
							key: "quantity",
							disabled:true,
							methods:{
								'on-change':({formData})=>{
									this.computedVolumn(formData)
								}
							}
						},
						{
							name: this.$t("Weight"),
							key: "weight",
							component: "InputNumber",
							bind:{
								style:'width:100%'
							},
							default:0,
							disabled:true,
							placeholder:()=>this.$t("enter")+this.$t("Weight"),
							methods:{
								'on-change':({formData})=>{
									this.computedVolumn(formData)
								}
							}
						},
						{
							name: this.$t("length"),
							key: "length",
							component: "InputNumber",
							bind:{
								style:'width:100%'
							},
							default:0,
							placeholder:()=>this.$t("enter")+this.$t("length"),
							methods:{
								'on-change':({formData})=>{
									this.computedVolumn(formData)
								}
							}
						},
						{
							name: this.$t("skuWidth"),
							key: "width",
							component: "InputNumber",
							bind:{
								style:'width:100%'
							},
							default:0,
							placeholder:()=>this.$t("enter")+this.$t("skuWidth"),
							methods:{
								'on-change':({formData})=>{
									this.computedVolumn(formData)
								}
							}
						},
						{
							name: this.$t("height"),
							key: "height",
							component: "InputNumber",
							bind:{
								style:'width:100%'
							},
							default:0,
							placeholder:()=>this.$t("enter")+this.$t("height"),
							methods:{
								'on-change':({formData})=>{
									this.computedVolumn(formData)
								}
							}
						},
						{
							name: this.$t("skuVolume"),
							key: "volume",
							component: "InputNumber",
							bind:{
								style:'width:100%'
							},
							default:0,
							disabled:true,
							placeholder:()=>this.$t("enter")+this.$t("skuVolume"),
						},
						{
							key: "create_time",
							name: this.$t("inboundTime"),
							component: "DatePicker",
							placeholder: () => this.$t("select") + this.$t("inboundTime"),
							bind: {
								clearable: false,
								type: "datetime",
								style: {
									width: "100%"
								}
							},
							disabledDate: true
						},
						{
							name: this.$t("Remarks"),
							key: "remarks",
							component: "Input",
							bind: {
								type: "textarea",
							},
							placeholder:()=>this.$t("enter")+this.$t("Remarks"),
						},
					]
				},
        add: {
					type:'add',
          methods: {
            ok({ row, close }) {
              this.$page.handleRequestMethods(row.id?'update':'add', row, true).then((e) => {
								if(!row.id)this.$page.copy(e.payload,this.$t('warehousingNumber'))
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              styles: {
                top: "30px",
              },
              width: 500,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
							client_id: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "blur",
									type:'number',
							  },
							],
            },
          },
          grid: [
            {client_id:24},
            {remarks:24},
          ],
          fields: [
						
            {
              key: "client_id",
              component: "Select",
							name:()=>this.$t("clientName"),
							show({formData}){
								return !this.$modal.params.id
							},
              placeholder() {
                return this.$t("select") + this.$t("clientName");
              },
              clearable: true,
              options: [],
              bind: {
                style: "width:150px",
              },
              config: { label: "account", value: "id" },
            },
            {
              key: "remarks",
              name: () => this.$t("Remarks"),
              component: "Input",
              bind: {
                type: "textarea",
              },
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
            },
          ],
        },
      },
      header: {
        searchs: [
					{
					  key: "start_time",
					  component: "DatePicker",
					  placeholder: () => this.$t("select") + this.$t("startingTime"),
					  bind: {
					    clearable: false,
					    type: "datetime",
					    style: {
					      width: "100%"
					    }
					  },
					  disabledDate: true
					},
					{
					  key: "end_time",
					  component: "DatePicker",
					  placeholder: () => this.$t("select") + this.$t("end")+this.$t('time'),
					  bind: {
					    clearable: false,
					    type: "datetime",
					    style: {
					      width: "100%"
					    }
					  },
					  disabledDate: true
					},
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px",
            },
            config: { label: "account", value: "id" },
          },
					{
					  key: "warehouse_id",
					  component: "Select",
					  placeholder() {
					    return this.$t("select") + this.$t("warehouseName");
					  },
					  clearable: true,
					  options: [],
					  config: { label: "title", value: "id" },
					  bind: {
					    style: "width:150px",
					  },
					},
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              fnName: "add",
              type: "add",
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
          	add(){
          		this.getModal('add').open({},function(){
          			this.setTitle(this.$t("add"));
          		})
          	},
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
        },
        {
          name: this.$t("clientName"),
          key: "client_name",
          minWidth: 120,
        },
				{
				  name: this.$t("warehouseName"),
				  key: "warehouse_name",
				  minWidth: 120,
				},
				{
				  name: this.$t("warehousingNumber"),
				  key: "warehouse_number",
				  minWidth: 120,
				},
				{
				  name: this.$t("noofpieces"),
				  key: "quantity",
				  minWidth: 120,
				},
				{
				  name: this.$t("Weight"),
				  key: "weight",
				  minWidth: 120,
				},
				{
				  name: this.$t("skuVolume"),
				  key: "volume",
				  minWidth: 120,
				},
				{
				  name: this.$t("Remarks"),
				  key: "remarks",
				  minWidth: 120,
				},
				{
				  name: this.$t("createUser"),
				  key: "create_name",
				  minWidth: 120,
				},
				{
				  name: this.$t("createTime"),
				  key: "create_time",
				  minWidth: 120,
				},
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
						{
						  name: () => this.$t("warehousingInformation"),
						  type: "warehousingInformation",
						  fnName: "warehousingInformation",
						  bind: {
						    type: "success",
						  },
						},
						
						
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success",
              },
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error",
              },
            },
          ],

          methods: {
						
						warehousingInformation({row}){
							this.getModal('info').open({tid:row.id,warehouse_number:row.warehouse_number},function(){
								this.$page.handleRequestMethods('inboundList',{id:row.id}).then(res=>{
									this.list = res.payload
								})
								this.setTitle(this.$t("warehousingInformation"));
							})
						},
            async updateFun({ row }) {
							this.getModal('add').open(row,function(){
								this.setTitle(this.$t("update"));
							})
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  "?",
                onOk: () => {
                  this.handleRequestMethods("del", row, true).then((res) => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped></style>
